import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag.service';
import { IDomainFeatureFlags } from '../../config/tenant.interface';

/**
 * Guards a route based on a domain-level feature flag.
 * Usage in routerConfig: { canActivate: [FeatureGuard], data: { feature: 'inventory' } }
 */
@Injectable({ providedIn: 'root' })
export class FeatureGuard implements CanActivate {
  constructor(
    private featureFlagService: FeatureFlagService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const flag = route.data?.['feature'] as keyof IDomainFeatureFlags | undefined;

    if (!flag || this.featureFlagService.isDomainFeatureEnabled(flag)) {
      return true;
    }

    this.router.navigate(['/dashboard']);
    return false;
  }
}
